module.exports = __webpack_public_path__ + "static/img/kid-group.46a4b70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/Wad/Wad-pics/kid-group.jpg
// module id = jJwh
// module chunks = 0